var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArizonaCardinalsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    height: 161.49,
    viewBox: "0 0 179.31167 161.48718",
    width: 179.31,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.25 0 0 -1.25 -294.47 573.03)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.70467 .93956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m377.42 353.53c0.3366 17.463-13.381 29.869-13.381 29.869-1.481 11.04-5.4927 27.008-26.87 38.798-32.46 17.889-50.42 3.2772-101.59 34.621 1.0649-5.8599 4.437-13.969 8.7332-19.006l-5.2907 1.735c3.8464-8.106 10.006-15.459 13.231-17.846l-5.9303 1.8635c6.2822-15.416 18.556-24.547 18.556-24.547 2.7968-23.602 20.11-27.623 21.509-42.139 22.555-3.4976 46.396-27.65 46.396-27.65 12.482 21.457 29.887 25.615 44.639 24.303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m334.46 419.24c-23.516 12.889-52.256 4.5196-88.979 27.271 3.6383-10.872 26.368-23.605 26.368-23.605l-20.113 6.5392c5.1224-8.8893 26.09-20.028 26.09-20.028l-18.758 6.0618c7.7694-12.904 25.395-21.613 25.395-21.613l-10.832 0.78335c1.4015-12.133 18.164-22.58 19.055-31.943 7.5827-2.8978 17.353-7.9499 24.97-14.498 14.56 7.1573 10.545 31.374-17.216 65.726 38.183-2.3072 37.13-30.615 59.046-26.545-1.6065 7.6041-2.6438 19.575-25.025 31.852",
    fill: "#97233f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.54 383.91c-4.9052-7.8948-13.198-5.6946-16.154 4.1494l5.9792-0.36415c-5.2418 3.1365-10.003 7.751-13.684 12.298-1.0833-21.747 19.382-31.509 26.151-16.236-0.765 0.006-1.53 0.0582-2.2919 0.153",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.46 107.45c-3.3928 6.9385-11.67 11.398-18.941 13.418 17.071 2.0464 31.109 8.8346 37.791 15.486-1.5338-11.23-11.613-24.326-18.85-28.904zm-17.168 19.73c-0.9443 0.0282-1.8853 0.0862-2.8203 0.17774 0 0 5.1141 8.6937 2.3027 18.271 11.1-6.2309 25.402-9.2482 35.848-7.1406-6.2646-5.3-21.166-11.732-35.33-11.309z",
    transform: "matrix(.8 0 0 -.8 227.23 467.12)",
    fill: "#ffb612"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArizonaCardinalsLogo);
export default __webpack_public_path__ + "static/media/arizona-cardinals-logo.5bb5f33f609ddd038e80a3a122f29a8d.svg";
export { ForwardRef as ReactComponent };